// IMPORTS
// OHS
import { OHSFormItem, OHSFormSubmit, OHSFormSubmitListener, OHSFormDataExtractor, OHSFormDataClearer, OHSFormSelectBuilder } from '../../../../../onehivesystems/js/OHSForm';
import OHSCRUD from '../../../../../onehivesystems/js/OHSCRUD';
// Assets
import { portTypes } from '../_variables';


// COMPONENT
export default function Additions (props) {
   // Function
   const addPorts = function () {
      OHSCRUD({
         url: '/v1/oneport/ports/additions/' + props.parent.deviceID,
         method: 'POST',
         payload: OHSFormDataExtractor('oneport-device-additions'),
         success: function (data) {
            props.parent.getPorts(); // refresh ports list
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup,
         showSuccessPopup: true,
         setOHSConfirmation: props.onehive.setConfirmation,
         confirmMessage: "Are you sure you wish to add additional ports? The new port(s) will be appended to the bottom of the list."
      });
   }
   
   // Component
   return (
      <div id='oneport-device-additions' className='oneport-device-additions' onKeyDown={(e) => {OHSFormSubmitListener(e, addPorts);}}>
         <OHSFormItem onehive={props.onehive} title="Number of Ports to Add">
            <input type='number' className='ohsinput' min={1} max={1000} defaultValue={1} data-ohsformdata='number_of_ports' />
         </OHSFormItem>
         <OHSFormItem onehive={props.onehive} title="Port Type">
            <OHSFormSelectBuilder onehive={props.onehive} content={portTypes} simple={true} blank={false} ohsformdata='port_type' />
         </OHSFormItem>
         <OHSFormItem onehive={props.onehive} title="Port Name Prefix">
            <input type='text' className='ohsinput' placeholder='(Optional)' data-ohsformdata='port_name_prefix' />
         </OHSFormItem>
         <OHSFormItem onehive={props.onehive} title="Port Name Suffix">
            <input type='text' className='ohsinput' placeholder='(Optional)' data-ohsformdata='port_name_suffix' />
         </OHSFormItem>
         <OHSFormSubmit onehive={props.onehive} add={addPorts} clear={() => {OHSFormDataClearer('oneport-device-additions');}} keyListener={true} />
      </div>
   );
}